<template>
    <div id="app">
        <v-app  v-model="show">          
           
            <v-card class="pa-3 yellow lighten-3" dense>               

                    <v-row class="align-center" dense>                       
                        <v-col cols="1" sm="1" md="1">
                            <v-text-field 
                                dense  
                                @keyup.enter="consultarNotaPedido(vvnpedido)"   
                                v-model="vvnpedido"
                                label="Ingrese NP" 
                                ref="inputNP"                       
                            ></v-text-field>                    
                        </v-col>                     

                        <v-col cols="auto"  >
                            <v-btn  dense x-small @click="mostrarBuscadorNP()">
                                ... 
                            </v-btn>                    
                        </v-col> 

                        <v-col cols="4" >
                            <v-text-field readonly   v-model="vvproveedor" 
                                label="Proveedor"                        
                            ></v-text-field>    
                        </v-col>                       
                        <v-col cols="2" sm="2" md="2" class=" red--text">
                            <v-text-field readonly   v-model="vvnp"
                                label="Nota Pedido"                        
                            ></v-text-field>    
                        </v-col>

                        


                        <!-- <v-col  cols="1" sm="1" md="1" class=" red--text">                          
                            <v-btn :disabled="vvnpedido == '' " v-model="vrecepcion" fab small color="green" 
                            @click="mostrarRecepcion()">
                                <v-icon>mdi-barcode</v-icon>
                            </v-btn>
                        </v-col> -->



                        <!-- <v-col cols="auto" v-if="vvnp!=''" class=" red--text">                                                           
                                <strong class="text-h5"> N° Pedido:   {{ vvnp }}  </strong>                                                            
                        </v-col>                      
                        <v-col dense cols="1" sm="1" md="1"   v-if="vvnp!=''">
                            <v-btn dense x-small @click="activarDatosNP=true">
                                Consultar mas datossss
                            </v-btn>                    
                        </v-col>  -->

                          
                        
                      

                        <!-- Espaciador para empujar el botón de imprimir -->
                        <v-spacer></v-spacer>

                        

                        <v-col dense cols="2" sm="2" md="2"   v-if="dessertsFichaNP.length>0">
                                <v-text-field
                                    v-model="searchNP"
                                    label="Buscar por Detalle NP"
                                    class="mr-50"
                                    @keyup="mayus(searchNP)"
                                    dense
                                    append-icon="mdi-magnify"
                                ></v-text-field>        

                        </v-col>
                        
                        
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                fab
                                small
                                color="green"
                                v-bind="attrs"
                                v-on="on"
                                :disabled="vvnpedido == '' " 
                                v-model="vrecepcion" 
                                @click="mostrarRecepcion(1)"
                                >
                                <v-icon>mdi-barcode</v-icon>
                                </v-btn>
                            </template>
                            <span>N° Serie</span>
                        </v-tooltip>

                        <!-- Botón de imprimir completamente alineado a la derecha -->                       
                        <v-col cols="auto" >
                                <v-btn class="mx-2" fab dark small color="green"  @click="exportarExcelNP()" >
                                    <v-icon dark>mdi-microsoft-excel</v-icon>
                                </v-btn>
                                <v-btn class="mx-2" fab dark small   color="blue" @click="imprimirNotaPedido()">
                                    <v-icon dark>mdi-printer</v-icon>
                                </v-btn>
                                                                     
					            <v-btn class="mx-2" fab dark small @click="irMenuInge()"   color="black"  >
                                    		<v-icon>mdi-close</v-icon>
                                </v-btn>                                     
                            

                                <!-- <v-btn class="mx-2" fab dark small   color="black"  @click="dialogFichaNP=false">
                                    <v-icon>mdi-close</v-icon>
                                </v-btn> -->
                        </v-col>
                    </v-row>
                    <v-row dense class="align-center compacto" >
                        <v-col cols="1" sm="1" md="1" class=" red--text">
                            <v-text-field readonly   v-model="vvfecha"
                                label="Fecha NP"                        
                            ></v-text-field>    
                        </v-col>
                        <v-col cols="5" sm="5" md="5" class=" red--text">
                            <v-text-field readonly   v-model="vvdestino"
                                label="Destino"                        
                            ></v-text-field>    
                        </v-col>
                        <v-col cols="2" sm="2" md="2" class=" red--text">
                            <v-text-field readonly   v-model="vvcomprador"
                                label="Comprador"                        
                            ></v-text-field>    
                        </v-col>
                        <v-col cols="1" sm="1" md="1" class=" red--text">
                            <v-text-field readonly   v-model="vvmoneda"
                                label="Moneda"                        
                            ></v-text-field>    
                        </v-col>
                        <v-col cols="1" sm="1" md="1" class=" red--text">
                            <v-text-field readonly   v-model="vvdescuento"
                                label="Desc.Gral"                        
                            ></v-text-field>    
                        </v-col>
                        <v-col cols="1" sm="1" md="1" class=" red--text">
                            <v-text-field readonly   v-model="vvtasa"
                                label="Tasa Iva"                        
                            ></v-text-field>    
                        </v-col>                     
                    </v-row> 
                    
                </v-card>
                
                <v-card class="pa-3 yellow lighten-4" dense>   

                    <v-row dense  >
                            <v-col dense cols="12">
                                <v-data-table                                   
                                        dense
                                        :headers="headersFichaNP"
                                        :items="dessertsFichaNP"    
                                        class="elevation-1"
                                        :search="searchNP"                                 
                                        height="800"
                                        fixed-header  
                                        :single-expand="true"
                                     
                                        item-key="id1"
                                        @item-expanded="onItemExpanded"
                                        :expanded.sync="expanded"

                                      

                                        :items-per-page.sync="itemsPerPage"
                                        :items-per-page-options="itemsPerPageOptions"
                                         :footer-props="{
                                            itemsPerPageText: 'Items por página',
                                        }"  

                                        
                                 >
                                    <template v-slot:item.cantidad="{ item }">
                                        <v-chip v-if="item.cantidad>'0'" color="yellow lighten-1"  
                                        v-model="item.cantidad"   
                                        @click="expandirDesdeCantidad(item)"
                                           
                                    >
                                                {{ item.cantidad }}
                                        </v-chip>      
                                    </template>
                                    <template v-slot:expanded-item="{ headers, item }">
                                        <td :colspan="headers.length" class="pa-0 ma-0">     
                                            <v-card flat class="pa-3 orange lighten-4" style="width: 100%;">
                                                <v-btn
                                                    icon
                                                    color="black"
                                                    @click="cerrarExpand"                      
                                                    style="position: absolute; top: 10px; right: 10px; z-index: 10;"
                                                >
                                                    <v-icon>mdi-close</v-icon>
                                                </v-btn>                                               
                                                <v-card-title>                                                                                        
                                                </v-card-title> 
                                                <v-card-text>                                               
                                                    <v-data-table
                                                        :headers="headersActivarResumen"
                                                        :items="dessertsResumen"
                                                        dense
                                                        :single-expand="true"
                                                        item-key="id"                                                       
                                                        :expanded.sync="expanded1"
                                                        hide-default-footer
                                                    >
                                                        <template v-slot:item.recibida="{ item }">
                                                            <v-chip v-if="item.recibida>'0'"  
                                                            v-model="item.recibida" 
                                                            color="yellow"  
                                                            @click="expandirDesdeRecibida(item)"
                                                            
                                                            >
                                                                    {{ item.recibida }}
                                                            </v-chip>      
                                                        </template>

                                                        <template v-slot:body.append>
                                                            <tr :colspan="headersActivarResumen.length" 
                                                                style=" font-weight: bold; text-align: center;">
                                                                <td></td>
                                                                <td></td>
                                                                <td></td>
                                                                <td></td>
                                                                <td >
                                                                    Total: {{ totalComprado }}
                                                                </td>                                                
                                                                <td >
                                                                    Total: {{ totalRecibida }}
                                                                </td>                                                                                             
                                                                <td >
                                                                    Total: {{ totalFaltante }}
                                                                </td>                                                                                       
                                                            </tr>
                                                        </template> 

                                                        <!-- <template v-slot:expanded-item="{ headers, item }">
                                                            <td :colspan="headers.length" class="pa-0 ma-0">
                                                            <v-card flat class="pa-3 orange lighten-4" style="width: 100%;">
                                                                <v-card-title class="text-h6">Remitos vinculados</v-card-title>

                                                             
                                                                <div v-if="vTipoRemito === 1" class="mt-4">
                                                                <v-data-table
                                                                    dense
                                                                    :headers="headersRemitosOT"
                                                                    :items="dessertsRemito"
                                                                    class="elevation-1"
                                                                    hide-default-footer
                                                                />
                                                                </div>

                                                                <div v-else-if="vTipoRemito === 2" class="mt-4">
                                                                <v-data-table
                                                                    dense
                                                                    :headers="headersRemitosEI079"
                                                                    :items="dessertsRemito"
                                                                    class="elevation-1"
                                                                    hide-default-footer
                                                                />
                                                                </div>
                                                            </v-card>
                                                            </td>
                                                        </template> -->
                                                        

                                                        

                                                        
                                                        
                                                    </v-data-table>
                                                </v-card-text>
                                            </v-card>
                                        </td>
                                    </template>
                                </v-data-table>
                            </v-col>

                        </v-row>

                        <!-- <v-row dense  >
                            <v-col dense cols="12">
                                <v-data-table                                   
                                        dense
                                        :headers="headersRemitosEI079"
                                        :items="dessertsRemito"    
                                        class="elevation-1"
                                        fixed-header  
                                        :single-expand="true"
                                     
                                       
                                        @item-expanded="onItemExpanded"
                                        :expanded.sync="expanded"
                                        :items-per-page.sync="itemsPerPage"
                                        :items-per-page-options="itemsPerPageOptions"
                                         :footer-props="{
                                            itemsPerPageText: 'Items por página',
                                        }" 

                                        
                                 >
                                </v-data-table>
                            </v-col>
                        </v-row>         -->
                        
                        <v-card class="pa-3 yellow lighten-4"  >
                            <v-row dense  class=" red--text" v-if="vvnp!=''">
                                    <v-col>
                                        <strong class="text-h5" >Subtotal: {{ parseFloat(vvSubTotal.replace(',','.')).toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }} </strong>
                                    </v-col>
                                    <v-col>
                                        <strong class="text-h5" >Descuento: {{  parseFloat(vvDescuento.replace(',','.')).toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }} </strong>
                                    </v-col>
                                    <v-col>
                                        <strong class="text-h5" >Neto: {{ parseFloat(vvNeto).toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }} </strong>
                                    </v-col>
                                    <v-col>
                                        <strong class="text-h5" >IVA: {{ parseFloat(vvIva.replace(',','.')).toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }} </strong>
                                    </v-col>
                                    <v-col>
                                        <strong class="text-h5">Total:  {{ vvmoneda }} {{ parseFloat(vvTotal.replace(',','.')).toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }} </strong> 
                                    </v-col>                                
                            </v-row>
                        </v-card>  
                        <div class="mt-4">
                            <v-card class="pa-3 yellow lighten-4" >  
                                <v-row  dense v-if="vvnp!=''">
                                    <v-col cols="12" sm="12" md="12">
                                        <strong> Plazo Entrega: </strong>   {{ vvplazoentrega }} 
                                    </v-col>
                                </v-row>
                                <v-row  dense v-if="vvnp!=''">
                                    <v-col cols ="auto">
                                        <strong> Forma de Pago:  </strong> {{ vvformapago }}
                                    </v-col>
                                </v-row>
                                <v-row  dense v-if="vvnp!=''">
                                    <v-col cols ="auto">
                                        <strong>  Lugar Entrega:  </strong>  {{ vvlugar }}
                                    </v-col>
                                </v-row>
                                <v-row  dense v-if="vvnp!=''">
                                    <v-col cols ="auto">
                                        <strong>Transporte:</strong> {{ vvtransporte }} 
                                    </v-col>
                                </v-row>
                                <v-row  dense v-if="vvnp!=''">
                                    <v-col cols ="auto">
                                        <strong> Reajuste:</strong> {{ vvreajuste }} 
                                    </v-col>
                                </v-row>
                                <v-row  dense v-if="vvnp!=''">
                                    <v-col cols ="auto">
                                        <strong> Cond. Particulares:</strong> {{ vvcodcondi }} 
                                    </v-col>
                                </v-row>
                            </v-card>    
                        </div>    
                </v-card>


                <!-- <v-card class="pa-3 yellow lighten-5" dense>  
                        <v-row dense  >
                            <v-col dense cols="12">
                                <v-data-table                                   
                                        dense
                                        :headers="headersRemitosEI079"
                                        :items="dessertsRemito"    
                                        class="elevation-1"
                                        fixed-header  
                                        :single-expand="true"
                                     
                                        item-key="item"
                                        @item-expanded="onItemExpanded"
                                        :expanded.sync="expanded"
                                        :items-per-page.sync="itemsPerPage"
                                        :items-per-page-options="itemsPerPageOptions"
                                         :footer-props="{
                                            itemsPerPageText: 'Items por página',
                                        }" 

                                        
                                 >
                                </v-data-table>
                            </v-col>
                        </v-row>        
                </v-card>             -->
               
               
                    
              
          
            

            <v-dialog
                v-model="dialogResumen"
                max-width="1400px"
                persistent

            >
                
                <v-card>  

                    <v-btn
                        icon
                        color="black"
                        @click="cerrarResumen"                      
                        style="position: absolute; top: 10px; right: 10px; z-index: 10;"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>

                    <v-card-title>
                        <v-row class="text-md-center red--text">
                            <v-col cols="12">
                              <h5>Destino del item de la nota de pedido</h5>  
                            </v-col>                           
                        </v-row>
                    </v-card-title> 
                    
                   


                    <v-card-text  >
                        <v-container v-if="loadingResumen" class="d-flex justify-center">
                            <v-progress-circular indeterminate color="primary"></v-progress-circular>
                        </v-container>
                        <v-container>
                          
                            
                            <v-row dense class="yellow lighten-4">

                                <v-col cols="1">
                                   <strong>  Item:  </strong> {{ varItemNP }}
                                </v-col>
                                <v-col cols="8">
                                  <strong>  Detalle: </strong>  {{ varDetalleNP }}
                                </v-col>
                                <v-col cols="3">
                                  <strong> Comprada: </strong> {{ varCantidadNP }}
                                </v-col>
                                
                            </v-row>
                           
                            <v-row dense>

                                <v-col cols="12">
                                    <v-data-table
                                        dense
                                        :headers="headersActivarResumen"
                                        :items="dessertsResumen"    
                                        class="elevation-1"  
                                        :items-per-page.sync="itemsPerPage"
                                        :items-per-page-options="itemsPerPageOptions" 
                                                                
                                                        
                                        >


                                        <template v-slot:item.recibida="{ item }">
                                            <v-chip v-if="item.recibida>'0'" color="yellow lighten-1"   v-model="item.recibida"         
                                                            @click="consultarRemitosVinculados(item)"
                                                            >
                                                            {{ item.recibida }}
                                            </v-chip>      
                                        </template>



                                        


                                        <template v-slot:body.append>
                                            <tr :colspan="headersActivarResumen.length" 
                                                style="background-color: #FFF9C4; font-weight: bold; text-align: center;">
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td >
                                                    Total: {{ totalComprado }}
                                                </td>                                                
                                                <td >
                                                    Total: {{ totalRecibida }}
                                                </td>                                                                                             
                                                <td >
                                                    Total: {{ totalFaltante }}
                                                </td>                                                                                       
                                            </tr>
                                        </template> 

                                    </v-data-table>
                                </v-col>

                            </v-row>
                           

                        </v-container>
                    </v-card-text>                    

                </v-card>         

            </v-dialog>         



            <v-dialog
                v-model="activarDatosNP"
                max-width="700px"
                persistent
            >
                
                <v-card class="position-relative" >  

                    <v-btn
                        icon
                        color="black"
                        @click="activarDatosNP = false"
                        style="position: absolute; top: 10px; right: 10px; z-index: 10;"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>


                    <v-card-text class="  mb-3 pa-3 yellow lighten-4">
                        <v-row dense>
                            <v-col cols="auto"  >                               
                               <strong> Fecha NP: </strong>  {{ vvfecha }}                                                            
                           </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="auto"  >                               
                               <strong> Proveedor: </strong>  {{ vvproveedor }}                                                            
                           </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="auto"  >  
                                <strong>  Comprador: </strong>     {{ vvcomprador }}   
                            </v-col>
                        </v-row>
                        <v-row dense >
                            <v-col cols="8"  >                               
                                <strong>  Destino: </strong>     {{ vvdestino }}                                                             
                            </v-col>   
                        </v-row>    
                        <v-row dense >
                            <v-col cols="3" sm="3" md="3" >
                               
                                <strong>  Desc. Gral:  </strong>     {{ vvdescuento }}
                                                             
                            </v-col>   
                            <v-col cols="3" sm="3" md="3" >
                                
                                <strong> Tasa Iva: </strong>     {{ vvtasa }}
                                                               
                            </v-col>
                            <v-col cols="3" sm="3" md="3" >
                               
                                <strong>  Moneda: </strong>     {{ vvmoneda }}
                                                             
                            </v-col>     
                                                                 
                        </v-row>
                    </v-card-text>                   
                </v-card> 

            </v-dialog>  
            
            

            <v-dialog
                v-model="dialogRemito"
                max-width="1000"
                persistent
            >
                
                <v-card class="pt-10">  

                    <v-btn
                        icon
                        color="black"
                        @click="dialogRemito = false"
                        style="position: absolute; top: 10px; right: 10px; z-index: 10;"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>


                    <!-- <v-card-title>
                        <v-row class="text-md-center red--text">
                            <v-col cols="12">
                              <h5> Datos del Remito </h5>  
                            </v-col>                           
                        </v-row>
                    </v-card-title>                   -->

                    <v-card-text  v-if="vTipoRemito === 1 ">
                        <v-container >
                            
                            <v-data-table

                                   
                                    dense
                                    :headers = "headersRemitosOT "
                                    :items="dessertsRemito"    
                                    class="elevation-1"  
                                    :items-per-page.sync="itemsPerPage"
                                    :items-per-page-options="itemsPerPageOptions" 
                                    hide-default-footer                           
                                                      
                            >                              

                            </v-data-table>                           

                        </v-container>
                    </v-card-text>
                    <v-card-text v-if="vTipoRemito === 2 ">        

                        <v-container >
                            
                            <v-data-table

                                   
                                    dense
                                    :headers="headersRemitosEI079"
                                    :items="dessertsRemito"    
                                    class="elevation-1"  
                                    :items-per-page.sync="itemsPerPage"
                                    :items-per-page-options="itemsPerPageOptions" 
                                    hide-default-footer                          
                                                      
                            >                              

                            </v-data-table>                           

                        </v-container>

                    </v-card-text>

                    
                </v-card>
            </v-dialog>


            <v-dialog v-model="loadingDialog" persistent width="300">
                <v-card class="d-flex flex-column align-center justify-center pa-5">
                    <v-img
                    src="https://cdn-icons-png.flaticon.com/512/3198/3198583.png"
                    width="80"
                    height="80"
                    class="mb-4"
                    ></v-img>
                    <span class="text-subtitle-1 font-weight-medium">Procesando datos...</span>
                    <span class="text-body-2 mt-2">Por favor aguarde un momento</span>
                </v-card>
            </v-dialog> 
            
            

            <v-dialog
                v-model="dialogRecepcion"
                max-width="1400px"
                persistent

            >
                
                <v-card>                  

                    <v-btn
                        icon
                        color="black"
                        @click="dialogRecepcion = false"
                        style="position: absolute; top: 10px; right: 10px; z-index: 10;"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    
                    
                    <v-card-text>                     
                                              
                            <v-row no-gutters class="d-flex justify-end align-center pa-2">
                                <v-col cols="auto" class="mr-8">                             
                                    <v-btn 
                                    class="mx-2" fab dark small color="green" @click="exportarRecepcion()" >
                                        <v-icon dark>mdi-microsoft-excel</v-icon>
                                        </v-btn>
                                </v-col>                    
                            </v-row>     
                            <v-row dense>
                                <v-col cols="12">
                                    <v-data-table
                                        dense
                                        :headers="headersRecepcion"
                                        :items="dessertsRecepcion"    
                                        class="elevation-1"  
                                        :items-per-page.sync="itemsPerPage"
                                        :items-per-page-options="itemsPerPageOptions"                                                               
                                    >

                                    </v-data-table>
                                </v-col>
                            </v-row>
                       
                    </v-card-text>
                                       

                </v-card>         

            </v-dialog>





            <BuscadorNotaPedido
            
                :visible="showvisible"                 
                :pflag="1"            
                @close="showvisible = false"
                @npSel="vNPSel = $event"
            
            >
        
            </BuscadorNotaPedido>
            

        

           

        

          
            
          

           

           

          

          

       

    
        </v-app>



    </div>
</template>








<script>

// import Axios from "../../../axios-auth-sistemas";


import Axios from "../../../axios-auth-sistemas";
import moment from "moment";
import  exportXlsFile from "export-from-json";
import jsPDF from "jspdf"; 
import "jspdf-autotable";
import BuscadorNotaPedido from "./BuscadorNotaPedido.vue";






export default {
    name:'FichaNotaPedido',
    data(){
        return{        
           expanded: [],
            headersNPOT: 
                    [
                    { text: "Consultar NP", value: "acciones", align: "center", sortable: false },         
			        {text: 'NP',value: 'npedido',  align: "center",sortable: false},
                    {text: 'Fecha',value: 'fecha' ,sortable: false },
                    {text: 'Destino',value: 'destino', width: "20%",   sortable: true,align: 'left'},
                    {text: 'Moneda',value: 'smoneda',  align: "center",sortable: false }, 
                    {text: 'Total',value: 'total',  align: "center",sortable: false }, 
			        {text: 'Saldo',value: 'saldo',  align: "center",sortable: false }, 
                    {text: 'Estado',value: 'estado',  align: "center",sortable: false },
                    {text: 'Proveedor',value: 'prov', width: "30%",   sortable: false,align: 'left'},                                   
                    ],         
            dessertsEnt:[],

            headersFichaNP: 
                    [
			        {text: 'Item',value: 'item',  align: "center" ,sortable: false, width: "5%"},
                    {text: 'Articulo',value: 'artic' ,sortable: false,align: "center" , width: "10%" },
                    {text: 'Cantidad',value: 'cantidad', sortable: false,align: "center" , width: "10%"}, 
                  //  {text: "",value: "data-table-expand", width: "0%"}, 
                    {text: 'Dto',value: 'dto',  align: "center",sortable: false , width: "5%"}, 
			        {text: 'Detalle',value: 'detalle' ,sortable: true,align: "left" , width: "25%"}, 
                    {text: 'Precio Unit.',value: 'precio', align: "center",sortable: false , width: "10%" },
                    {text: 'Total',value: 'totart',  align: "center",sortable: false , width: "10%" },  
                    {text: 'Plazo',value: 'plazo', align: "center",sortable: false , width: "5%"}, 
                    //{text: 'Renglon',value: 'renglon',  align: "center",sortable: false },                    
                 ], 

             
                 
            headersActivarResumen: 
                [
                    {text: 'EI079',value: 'ei079',  align: "center",sortable: false},
                    {text: 'Item EI079',value: 'itemei079' ,  align: "center",  sortable: false },
                    {text: 'OT',value: 'otrabajo',  align: "center",sortable: false }, 
			        {text: 'Item',value: 'item' ,sortable: false, align: "center" }, 
                    {text: 'Comprada',value: 'cantidad',  align: "center",sortable: false },
                    {text: 'Recibida',value: 'recibida',  align: "center",sortable: false },
                    {text: 'Faltante',value: 'falta',  align: "center",sortable: false }, 
                  
			       
                 ], 



            headersRemitosOT: 
                [
                    {text: 'Remito',value: 'remito',  align: "center",sortable: false},
                    {text: 'Fecha',value: 'fecha' ,  align: "center", sortable: false },
                   // {text: 'Proveedor',value: 'proveedor',  align: "center",sortable: false }, 
			        {text: 'Cantidad',value: 'cantidad' , align: "center",sortable: false }, 
                    {text: 'OT',value: 'otrabajo',  align: "center",sortable: false },
                    {text: 'Item',value: 'item',  align: "center",sortable: false },
                    //{text: 'Recepciono',value: 'recepcion',  align: "center",sortable: false }, 
                    {text: 'Transporte',value: 'transporte',  align: "center",sortable: false },
                   // {text: 'Nota Pedido',value: 'np',  align: "center",sortable: false }, 
                   // {text: 'Material',value: 'material',  align: "center",sortable: false }, 

			       
                 ],      


            headersRemitosEI079: 
                [
                    {text: 'Remito',value: 'remito',  align: "center",sortable: false},
                    {text: 'Fecha',value: 'fecha' ,  align: "center", sortable: false },
                   // {text: 'Proveedor',value: 'proveedor',  align: "center",sortable: false }, 
			        {text: 'Cantidad',value: 'cantidad' , align: "center", sortable: false }, 
                    {text: 'EI079',value: 'ei079',  align: "center",sortable: false },
                    {text: 'Item EI079',value: 'itemEi079',  align: "center",sortable: false },
                    {text: 'Recepciono',value: 'recepcion',  align: "center",sortable: false }, 
                    {text: 'Transporte',value: 'transporte',  align: "center",sortable: false },
                    //{text: 'Nota Pedido',value: 'np',  align: "center",sortable: false }, 
                    //{text: 'Material',value: 'material',  align: "center",sortable: false }, 

			       
                 ],          
     


            filtro:"0",
          

            estado:false,

            item:0,

          
            itemsPerPage: -1, // Configura itemsPerPage en -1 para mostrar todos los elementos por defecto
            itemsPerPageOptions: [-1,10, 25, 50,75,100,200],


            fecha:'',

            btnNP:false,
            dialogNP:false,
            dessertsNPOT:[],
            searchFichaNP:'',


            dialogFichaNP:false,
            dessertsFichaNP:[],
            vvnp:'',
            vvrev0:0,
            vvrev1:0,
            vvfecha:'',
            vvproveedor:'',
            vvcomprador:'',
            vvdestino:'', 
            vvdescuento:'',
            vvtasa:'', 
            vvmoneda:'', 
            vvplazoentrega:'',    
            vvformapago:'',
            vvlugar:'', 
            vvtransporte:'',
            vvreajuste:'',
            vvnpedido:'',
            vvcodcondi:'',
            vvSubTotal:0,
            vvTotal:0,
            vvIva:0,
            vvDescuento:0,
            vvMoneda:0,
            vvNeto:0,
            searchNP:'',

            dialogResumen:false,
            dessertsResumen:[],
            varItemNP:'',
            varDetalleNP:'',
            varCantidadNP:'',  
            loadingResumen:false,
            totalComprado:0,
            totalFaltante:0,
            totalRecibida:0,
            
            dialogRemito:false,
            dessertsRemito:[],    
            vTipoRemito: 1,  
            activarDatosNP:false,

            showvisible:false,
            flag:0,
            vNPSel:'',

            imprimirNP:'',
            filtroNP:"1",
            
            dessertImprimir:[],

            nroALetra:'',

            itemsNP:[],

            expanded: [],
            expanded1: [],

            itemRemitoActivo: {},

            vrecepcion:"", 
            dessertsRecepcion:[],
            headersRecepcion: 
                [
                    {text: 'Recepcion',value: 'recepcion',  align: "center",sortable: false},
                    {text: 'Fecha',value: 'fecha' ,  align: "center", sortable: false },
                    {text: 'Otrabajo',value: 'otrabajo',  align: "center",sortable: false }, 
                    {text: 'Item',value: 'item',  align: "center",sortable: false }, 
			        {text: 'Cantidad',value: 'cantidad' , align: "center", sortable: false }, 
                    {text: 'N° Serie',value: 'serie',  align: "center",sortable: false },
                    {text: 'Numero',value: 'numero',  align: "center",sortable: false },
                    {text: 'Articulo',value: 'articulo',  align: "center",sortable: false }, 
                    {text: 'Descripcion',value: 'descrip',  align: "center",sortable: false },
                    {text: 'Nota Pedido',value: 'npedido',  align: "center",sortable: false },                    

			       
                 ], 

            dialogRecepcion:false,     
                 

            loadingDialog:false,   

            varNOTAPED:'',  






         

        }
    },

    computed:{

       

        
      
        
        
    },

    
    components: { 

        BuscadorNotaPedido
    },


  
    watch: {
        
     

        // vNPSel: function () {
        //     console.log("estoy en el watched")
        //    // this.consultarNotaPedido(this.vNPSel)

        //    let NPLocal="";
        //    NPLocal = String(this.vNPSel).padStart(6, '0');

        //    const NPEncontrado = this.itemsNP.find(item => item.npedido === NPLocal);
        //     if (NPEncontrado) {
        //         this.vvnpedido = NPEncontrado.npedido;                 
        //         this.consultarNotaPedido(this.vvnpedido);
        //     } 


        // },


        // vNPSel: {

        //     immediate: true, // Se ejecuta al montar el componente si vNPSel tiene un valor
        //     handler(newVal) {
        //     console.log("Estoy en el watcher, Nota de Pedido recibida:", newVal);

        //     if (!newVal) return; // Si no hay nota de pedido, no hace nada

        //     let NPLocal = String(newVal).padStart(6, "0"); // Asegurar formato

        //     // Esperar a que itemsNP tenga datos antes de buscar
        //     this.$nextTick(() => {
        //         const NPEncontrado = this.itemsNP.find((item) => String(item.npedido) === NPLocal);

        //         if (NPEncontrado) {
        //         this.vvnpedido = NPEncontrado.npedido; // Seleccionar en el combobox
        //         this.consultarNotaPedido(this.vvnpedido); // Llamar a la función
        //         } else {
        //         console.warn("Nota de pedido no encontrada:", NPLocal);
        //         }
        //     });
        //     },

        // },



        // vNPSel: {
        //     immediate: true,
        //     handler(newVal) {
        //     console.log("Watcher activado con Nota de Pedido:", newVal);
        //     if (!newVal) return;

        //     let NPLocal = String(newVal).padStart(6, "0"); // Asegurar formato

        //     this.$nextTick(() => {
        //         const NPEncontrado = this.itemsNP.find((item) => String(item.npedido) === NPLocal);

        //         if (NPEncontrado) {
        //         this.vvnpedido = NPEncontrado; // Guarda el objeto completo
        //         this.consultarNotaPedido(this.vvnpedido.npedido);
        //         } else {
        //         console.warn("Nota de pedido no encontrada:", NPLocal);
        //         }
        //     });
        //     },
        // },



        vNPSel: function () {
            console.log("estoy en el watched", this.vNPSel)
           // this.consultarNotaPedido(this.vNPSel)

           let NPLocal="";
           NPLocal = String(this.vNPSel).padStart(6, '0');
           this.consultarNotaPedido(NPLocal);
            

        },

       

       
    },      

    computed: {    
      
        show: {
            get() {
               
                

              
            },
            set(value) {
                if (!value) {
                  
                }
            },
        },  

       
    },

    mounted() {

       
       
        this.$nextTick(() => {
            if (this.$refs.inputNP) {
                this.$refs.inputNP.focus();
            }
        });
    

     //   this.cargarNP();
        
    },  

    created(){
       
    },
    
   

    methods: { 

        irMenuInge(){

            this.$router.push({ name: 'MenuInge' });
        },
        
        cerrarExpand(){
            this.expanded = []; 
        },

        cerrarExpand1(){
            this.expanded1 = []; 
        },

        expandirDesde(item) {
    
            this.activarResumen(item);
            this.expanded = [item]; 

        },


        expandirDesdeRecibida(item) {
    
           console.log("expandirDesdeRecibida", item)
            this.consultarRemitosVinculados(item);
           

        },


        expandirDesdeCantidad(item) {
    
            this.activarResumen(item);
            this.expanded = [item]; 

        },


        onItemExpanded({ item, value }) {
            if (value) {
            this.activarResumen(item);
            }
        },

       
        cerrarResumen(){
        this.dialogResumen = false;
        this.loadingResumen=false;
        this.dessertsResumen = [];
        this.dialogRemito =false;
        this.dessertsRemito = [];
        },

        
        // cargarNP(){

        //     Axios              
        //     .get("/Ti/NotaPedidoBuscador")
        //     .then(r => {       

        //         console.log("datosss", r.data)
                
        //         this.itemsNP= r.data;
            

                            
        //     }).catch(r => {        
        //             console.log("error en el mostrar las notas de pedido")
        //             this.$swal("","Error en el buscador de orden de trabajo", "info")
        //     });


        // },
        
        showAlert(alertInfo) {
            alertInfo.vm.$swal.fire({
                icon: alertInfo.icon,
                title: alertInfo.title,
                showConfirmButton: false,
                background: "#ececec",
                timer: 2000,
            });
        },

        
        filterOnlyCapsText (value, search, item) {
            return value != null &&
                search != null &&
                typeof value === 'string' &&
                value.toString().toLocaleUpperCase().indexOf(search) !== -1
        },

        mayus(e) {
           
                this.searchNP= this.searchNP.toUpperCase();
                this.searchFichaNP= this.searchFichaNP.toUpperCase();
                //e.value = e.value.toUpperCase();
        },         

        consultarNotaPedido(id){

                    console.log("NP ingresada",id)

                    this.dialogResumen = false;
                    this.loadingResumen=false;
                    this.dessertsResumen = [];
                    this.dialogRemito =false;
                    this.dessertsRemito = [];
                    this.expanded = []; 


                    this.dessertsFichaNP = [];
                    this.dessertsResumen = [];
                    this.dialogFichaNP =false;
                    let codCondi =0;
                    this.searchNP ="";
                    this.varNOTAPED ="";

                   // let vNP=  String(id).padStart(6, '0');
                    
                    let vNP ="";
                    if(id.npedido == undefined)
                    {
                        vNP=  String(id).padStart(6, '0');
                    }
                    else
                    {
                        vNP=  String(id.npedido).padStart(6, '0');
                    }
                    


                    Axios               
                    .get("/Ti/NotasPedidos?", {
                    params: {
                       id: vNP ,                 
                      
                    },
                    })
                    .then(r => {   

                        console.log("datos de la np", r.data)
                        if (r.data.length > 0 )    
                        {

                            r.data.forEach(element => {
                           
                          


                            this.dessertsFichaNP.push({
                                //item: element.item == 0 ? "" : parseInt(element.item.replace(/\./g, ''), 10) / 100000,
                                item: element.item == 0 ? "" : element.item,
                                artic:   element.artic == "0" ? ""  :  element.artic ,
                                cantidad:  element.cantidad == "0" ? "" : element.cantidad  ,
                                dto:  element.dto == "0" ? "" :  element.dto  ,                               
                                detalle:  element.detalle == "0" ? "" : element.detalle  ,
                                precio: element.precio == "0" ? "" : (element.precio) ,
                                totart:  element.totart == "0" ? "" : (element.totart) ,
                                plazo: element.plazo == "0" ? ""  : element.plazo  ,
                                renglon: element.renglon,
                                id1: element.id1 

                                                                          
                                })

                            });

                            this.vvnpedido =  r.data[0].npedido;
                            this.varNOTAPED =  r.data[0].npedido;   
                            this.vvnp = r.data[0].id  + " - " +   String(  r.data[0].npedido).padStart(6, '0');

                            
                            const fechaStr = r.data[0].fecha;

                            //this.vvfecha= moment(r.data[0].fecha, "YYYY-MM-DD").format("DD/MM/YYYY")
                            this.vvfecha = moment(r.data[0].fecha, "DD/MM/YYYY HH:mm:ss").format("DD/MM/YYYY");


                            this.vvproveedor = r.data[0].proveedor + " - " +  r.data[0].nombre;
                            this.vvcomprador =  r.data[0].comprador;
                            this.vvdestino =  r.data[0].destino;
                            this.vvdescuento =  r.data[0].descuento;
                            this.vvtasa = r.data[0].tasaiva;
                            this.vvmoneda = r.data[0].smoneda;
                            
                               
                            if(r.data[0].plazoEnt2 == null){
                                this.vvplazoentrega = r.data[0].plazoEnt1;
                            }
                            else{
                                this.vvplazoentrega = r.data[0].plazoEnt1 + r.data[0].plazoEnt2 ;
                            }
                             
                            this.vvformapago =  r.data[0].fpago;
                            this.vvlugar =  r.data[0].lentr;
                            this.vvtransporte =  r.data[0].trans;
                            this.vvreajuste =  r.data[0].reajus;
                            this.codCondi = r.data[0].codcondi;
                            this.codCondi = this.codCondi;
                            if(this.codCondi != 0)
                            {
                                this.vvcodcondi = this.codCondi ;
                            }
                            this.vvSubTotal = r.data[0].subtotal;
                            this.vvTotal = r.data[0].total;
                            this.vvDescuento = r.data[0].descuento;
                            this.vvMoneda =r.data[0].smoneda;
                            this.vvIva = r.data[0].iva;
                            if(parseFloat(r.data[0].descuento)>0)
                            {
                                this.vvNeto = parseFloat ( r.data[0].subtotal) - parseFloat (r.data[0].descuento);
                            }
                            else{
                                this.vvNeto = parseFloat (r.data[0].subtotal);
                            }

                            this.dialogFichaNP =true;

                        }
                        else{

                            
                           
                            this.$swal("", "Nota de Pedido ingresada inexistente", "info")

                            this.dialogFichaNP =false;


                        }
                        
                        
                    

                    }).catch(r => {        
                           
                        this.$swal("", "Nota de Pedido ingresada inexistente", "info")
                        this.dialogFichaNP =false;

                    });

        },


        activarResumen(item) {
                console.log("Estoy en activarResumen", item);

                this.dessertsResumen = [];
              //  this.dialogResumen = true;
                this.loadingResumen = true; 
                this.dessertsRemito =[];

                this.varItemNP = item.item;
                this.varDetalleNP = item.detalle;
                this.varCantidadNP = item.cantidad;


                this.totalComprado=0;
                this.totalFaltante=0;
                this.totalRecibida=0;
                

                Axios.get("/Ti/NotasPedidosOTEI079?", {
                    params: {
                        id: this.vvnpedido,
                        id1: item.renglon
                    }
                })
                .then(response => {
                    console.log("remitos", response);

                    if (!response.data || response.data.length === 0) {
                        this.$swal("", "No hay datos disponibles para esta Nota de Pedido", "info");
                        this.loadingResumen = false; // ✅ Detenemos el reloj si no hay datos
                        return;
                    }

                    // 🔹 Llenamos dessertsResumen
                    // this.dessertsResumen = response.data.map(element => ({
                    //     ei079: element.eI079 || "",
                    //     itemei079: element.itemEI079 || "",
                    //     cantidadei079: element.cantidadEI079 || "",
                    //     otrabajo: element.ot || "",
                    //     item: element.item || "", 
                    //     cantidad: element.cantidadEI079 || element.cantidadOT,
                    //     recibida: element.recibida || 0,
                    //     falta: element.faltante || 0,
                    //     renglon: element.eI079 ? element.renglonEI079 : element.renglonOT
                    // }));                



                    response.data.forEach(element => {                         
                          
                          this.dessertsResumen.push({
                          ei079: element.eI079 == "" ? "" :  element.eI079 ,
                          itemei079 : element.itemEI079 == "" ? "" :  element.itemEI079  ,
                          cantidadei079: element.cantidadEI079 =="" ? "" : element.cantidadEI079 ,
                          otrabajo: element.ot == "" ? "" : element.ot,
                          item: element.item == "" ? "" : element.item , 
                          cantidad: element.eI079  =="" ? element.cantidadOT : element.cantidadEI079,
                          recibida: element.recibida == "" ? "": element.recibida ,
                          falta: element.faltante  == "" ? "" : element.faltante,
                          renglon:  element.eI079 ? element.renglonEI079 : element.renglonOT,
                          id: element.id

                          })
  
                    });
  

                    // 🔹 Esperamos que Vue reactive los datos antes de calcular los totales
                    this.$nextTick(() => {
                        this.calcularTotales(); // ✅ Ahora se ejecuta cuando los datos ya están listos
                        this.loadingResumen = false; // ✅ Detenemos el reloj solo cuando todo termina
                    });

                })
                .catch(error => {
                    console.error("Error al obtener datos:", error);
                    this.$swal("", "Problemas con la cantidad recibida", "error");
                    this.loadingResumen = false; // ✅ Asegurar que el loading se apague en caso de error
                });

        },      

        calcularTotales(){


            console.log("calcular totales", this.dessertsResumen)

            // this.totalRecibida = this.dessertsResumen.reduce((sum, item) => sum + (Number(item.recibida) || 0), 0);
    
    
            // this.totalFaltante = this.dessertsResumen.reduce((sum, item) => sum + (Number(item.falta) || 0), 0);
    
            // this.totalComprado =  this.dessertsResumen.reduce((sum, item) => sum + (Number(item.cantidad) || 0), 0);


            this.totalRecibida = this.dessertsResumen.reduce((sum, item) => {
                return sum + Number((item.recibida || "0").replace(',', '.'));
            }, 0);

            this.totalFaltante = this.dessertsResumen.reduce((sum, item) => {
                return sum + Number((item.falta || "0").replace(',', '.'));
            }, 0);

            this.totalComprado = this.dessertsResumen.reduce((sum, item) => {
                return sum + Number((item.cantidad || "0").replace(',', '.'));
            }, 0);
        

        },



        consultarRemitosVinculados(item)
        {

                console.log("estoy en los remitos vinculados", item)
                this.dessertsRemito = [];
                this.vTipoRemito=item.otrabajo == null || item.otrabajo == ""  ? 2 : 1;
                

                console.log(item)
                console.log("tipo de remitp", this.vTipoRemito)

                Axios               
                .get("/Ti/NotasPedidosRemitosVinculados?", {
                params: {
                    id: this.vvnpedido,
                    id1: item.renglon,
                    id2:  item.otrabajo == null || item.otrabajo == "" ? item.ei079 : item.otrabajo,
                    id3:  item.otrabajo == null || item.otrabajo == "" ? item.itemei079 : item.item,
                    id4:item.otrabajo == null || item.otrabajo == "" ? '2' : '1',
                    
                },
                })
                .then(response => {                 

                       
                        this.dessertsRemito = response.data;

                        this.dialogRemito = true;
                       
                        // this.$nextTick(() => {
                        //     console.log("dessertsRemito",    this.dessertsRemito )
                         
                        // this.expanded1 = [item.id]; // o el campo que uses como item-key
                        // }); 

                    
                }).catch(r => {        
                    
                        this.$swal("","Problemas con la cantidad recibida", "info")
                });  




        },


        // formatearNumero(value) {
        //         if (!value) return "0";
        //         return parseFloat(value).toLocaleString("es-AR", { minimumFractionDigits: 2 });
        // },



        formatearNumero(value) {
            if (!value || value === "0" || value != undefined ) return "0";
            
            // Reemplazar coma por punto antes de convertir a número
            let numero = parseFloat(value.replace(",", "."));

            return numero.toLocaleString("es-AR", { minimumFractionDigits: 2 });
        },



        mostrarBuscadorNP(){

            this.flag=1;
            this.showvisible=true;

        },      


        imprimirNotaPedido(){

            if (this.filtroNP ==0){
                this.$swal("", "Es obligatorio seleccionar una opción con precio o sin precio", "info");
                return;
            }

            Axios               
            .get("/Ti/NotasPedidos?", {
            params: {
                id: this.vvnpedido,                      
            },
            })
            .then(r => {   

                    console.log("datos de la np", r.data);


                    this.dessertImprimir = [];

                    if (r.data.length === 0) {
                        this.$swal("", "No hay datos de nota de pedido para el ID ingresado", "info");
                        return;
                    }

                    r.data.forEach(element => {
                        let condicion = 0;    
                        if (element.codcondi > 0) {
                            condicion = element.codcondi;  
                        }

                        let plazo = (element.plazoEnt1 && element.plazoEnt1.trim() !== "" ? element.plazoEnt1 + " " : "") +
                                    (element.plazoEnt2 && element.plazoEnt2.trim() !== "" ? element.plazoEnt2 : "");

                        //let neto = element.descuento != "0" ? element.subtotal - element.descuento : element.subtotal;
                        
                        let neto = element.descuento != "0" ? parseFloat(element.subtotal.replace(',','.')) - parseFloat(element.descuento.replace(',','.')) : parseFloat(element.subtotal.replace(',','.'));

                       // let fechaFormateada = moment(element.fecha, "DD/MM/YYYY HH:mm:ss").format("DD/MM/YYYY");


                       let fechaFormateada = element.fecha;

                        if (fechaFormateada && typeof fechaFormateada === "string") {
                        const fechaMoment = moment(fechaFormateada, [
                            "D/M/YYYY HH:mm:ss",
                            "D/M/YYYY HH:mm",
                            "D/M/YYYY",
                            "DD/MM/YYYY HH:mm:ss",
                            "DD/MM/YYYY HH:mm",
                            "DD/MM/YYYY",
                            "YYYY-MM-DD HH:mm:ss",
                            "YYYY-MM-DD"
                        ], false); 

                        if (fechaMoment.isValid()) {
                            fechaFormateada = fechaMoment.format("DD/MM/YYYY");
                        } else {
                            console.warn("⚠️ Fecha inválida:", fechaFormateada);
                            fechaFormateada = "";
                        }
                        } else {
                        fechaFormateada = "";
                        }




                        let total= parseFloat(element.total.replace(',','.'));
                        let subtotal= parseFloat(element.subtotal.replace(',','.'));
                        let iva= parseFloat(element.iva.replace(',','.'));
                        let descuento= parseFloat(element.descuento.replace(',','.'));


                        let NetoFormat = neto.toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });    
                        let TotalFormat = total.toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                        let SubtotalFormat = subtotal.toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                        let DescuentoFormat = descuento.toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                        let IvaFormat = iva.toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

                        console.log("neto formateado", NetoFormat)

                        this.dessertImprimir.push({
                           // item: element.item == "0" ||  element.item == ""  ? "" : parseInt(element.item.replace(/\./g, ''), 10) / 100000,
                           item: element.item == "0" ||  element.item == ""  ? "" : element.item ,
                            artic: element.artic == "0" ? "" : element.artic,
                            cantidad: element.cantidad == "0" ||  element.cantidad == "" ? "" : element.cantidad,
                            descuento: element.descuento == "0" ? "" : DescuentoFormat,                               
                            detalle: element.detalle == "0" ? "" : element.detalle,
                            precio: element.precio == "0" ? "" : this.filtroNP == 1 ? element.precio : "",
                            totart: element.totart == "0" ? "" : this.filtroNP == 1 ? element.totart: "" ,
                            plazo: plazo,
                            renglon: element.renglon,
                            id:element.id, 
                            np: element.npedido,
                            fecha: fechaFormateada,
                            proveedorC: element.proveedor,
                            proveedorN:  element.nombre,
                            comprador: element.comprador,
                            destino: element.destino,
                            tasa: element.tasaiva,
                            moneda: element.smoneda,
                            formapago: element.fpago,
                            lugar: element.lentr,
                            transporte: element.trans,
                            reajuste: element.reajus,
                            condicion: condicion,
                            subtotal: this.filtroNP == 1 ? SubtotalFormat : "",
                            total:  this.filtroNP == 1 ? TotalFormat : "",
                            iva:  this.filtroNP == 1 ?  IvaFormat : "",
                            neto:   this.filtroNP == 1 ? NetoFormat : "",                            
                            calle: element.calle,
                            barrio: element.barrio,
                            ciudad: element.ciudad

                        });
                    });

                    console.log("array de imprimir", this.dessertImprimir);

                    this.generarPDF();


            }).catch(r => {        
                
                this.$swal("", "No se cargo la nota de pedido", "info")
                this.dialogFichaNP =false;

            });

        },



        // generarPDF(){


        //         var vm = this;      
        //         var columns = [
        //         {title: "IT", dataKey: "item"},
        //         {title: "Cant.", dataKey: "cantidad"},
        //         {title: "Articulo", dataKey: "artic"},
        //         {title: "Descripcion", dataKey: "detalle"},
        //         {title: "Precio Unit.", dataKey: "precio"},
        //         {title: "Importe", dataKey: "totart"},

        //         ];

        //         var doc = new jsPDF();

        //         var rows = vm.dessertImprimir.map(dessertImprimir => ({
        //             item: dessertImprimir.item,
        //             cantidad: dessertImprimir.cantidad,
        //             artic: dessertImprimir.artic,
        //             detalle: dessertImprimir.detalle,
        //             precio: dessertImprimir.precio,
        //             totart: dessertImprimir.totart
        //         }));


        //         doc.setLineWidth(0.5);

        //         doc.line(10, 11, 200, 11);           
        //         doc.line(10, 11, 10, 41);

        //         doc.addImage(
        //             "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",
        //             "JPEG",
        //             15,
        //             15,
        //             22,
        //             22
        //         );
        //         doc.setFontSize(6);
        //         doc.text("X" , 100, 15);
        //         doc.setFontSize(5);
        //         doc.text("Documento no valido como factura" , 80, 17);

        //         let npA = vm.dessertImprimir[0].id + " - " + vm.dessertImprimir[0].np;
        //         let provA= vm.dessertImprimir[0].proveedorC + " - " + vm.dessertImprimir[0].proveedorN;

        //         doc.setFontSize(12);
        //         // doc.text("NOTA DE PEDIDO N°: " + npA  , 42, 25);


        //         doc.setFillColor(220, 220, 220); // Gris claro (RGB)
        //         doc.rect(40, 20, 80, 8, "F"); // Dibuja un rectángulo de fondo

        //         doc.setTextColor(0, 0, 0); // Texto en negro
        //         doc.text("NOTA DE PEDIDO N°: " + npA, 42, 25);

        //         doc.setFontSize(12);
        //         doc.text("FECHA DE EMISION: " + vm.dessertImprimir[0].fecha  , 132, 25);

        //         doc.setFontSize(8);
        //         doc.text("SEÑOR(ES): " + provA  , 42, 31);

        //         let domi = vm.dessertImprimir[0].calle + " " + vm.dessertImprimir[0].barrio + " " +   vm.dessertImprimir[0].ciudad ;

        //         doc.setFontSize(7);
        //         doc.text("" + domi  , 59, 36);

        //         doc.setFontSize(7);
        //         doc.text("COMPRADOR: " +  vm.dessertImprimir[0].comprador  , 10, 47);  

        //         doc.setFontSize(8);
        //         doc.text("CONDICIONES DE PAGO: " +  vm.dessertImprimir[0].condicion  , 10, 52);                    
        //         doc.text("REAJUSTE DE PRECIOS: " +  vm.dessertImprimir[0].reajuste  , 10, 57);
        //         doc.text("PLAZO DE ENTREGA: " +  vm.dessertImprimir[0].plazo  , 10, 62);


        //         doc.line(40, 11, 40, 41);                    

        //         doc.line(10, 41, 200, 41);
        //         doc.line(200, 11, 200, 41);
        //         doc.setFontSize(10);


        //         let subtotal = vm.dessertImprimir[0].subtotal;
        //         let descuento = vm.dessertImprimir[0].descuento;
        //         let neto = vm.dessertImprimir[0].neto;
        //         let total =vm.dessertImprimir[0].total;

        //         // Agregar la fila extra al final con los totales
        //         rows.push(
        //             { item: "", cantidad: "", artic: "", detalle: "", precio: "SUBTOTAL", totart: subtotal },
        //             { item: "", cantidad: "", artic: "", detalle: "", precio: "DESCUENTO", totart: descuento },
        //             { item: "", cantidad: "", artic: "", detalle: "", precio: "NETO", totart: neto },
        //             { item: "", cantidad: "", artic: "", detalle: "", precio: "TOTAL", totart: vm.dessertImprimir[0].moneda + " " +  total }
        //         );

        //         //  Generar la tabla con estilos

        //         doc.autoTable({
        //             columns: columns,
        //             body: rows, // Incluir los datos + la fila de totales
        //             startY: 65, // Posición de inicio
        //             margin: { top: 25, left: 10, right: 10 },
        //             styles: { fontSize: 8 },
        //             headStyles: { fillColor: [41, 128, 185], textColor: [255, 255, 255] }, // Azul en el encabezado
        //             bodyStyles: { textColor: [0, 0, 0], fillColor: [255, 255, 255] }, // Fondo blanco en el cuerpo
        //             columnStyles: {
        //                 precio: { fontStyle: "bold", halign: "right" }, // Alinear textos de SUBTOTAL, etc.
        //                 totart: { fontStyle: "bold", halign: "right" }  // Alinear valores numéricos
        //             },
        //             didParseCell: function (data) {
        //                 // Pintar la fila de SUBTOTAL, DESCUENTO, NETO y TOTAL en gris
        //                 if (data.row.index >= rows.length - 4) {
        //                     data.cell.styles.fillColor = [200, 200, 200]; // Gris claro
        //                     data.cell.styles.fontStyle = "bold";
        //                 }
        //                 // Pintar la fila de TOTAL con un gris más oscuro
        //                 if (data.row.index === rows.length - 1) {
        //                     data.cell.styles.fillColor = [150, 150, 150]; // Gris más oscuro
        //                     data.cell.styles.fontStyle = "bold";
        //                     data.cell.styles.textColor = [255, 255, 255]; // Texto en blanco
        //                 }
        //             }
        //         });
        //         var finalO =  doc.autoTable.previous.finalY + 20;

        //         if (finalO >= 285) {
        //             doc.addPage();
        //             finalO = 0;
        //         }

        //         finalO = finalO + 3;

        //         doc.setFontSize(8);

        //         let total1 = vm.dessertImprimir[0].total;

        //         // Reemplaza separadores de miles y convierte a número decimal
        //         total1 = parseFloat(total1.replace(/\./g, "").replace(",", "."));


        //         //doc.text("Son:  " + vm.dessertImprimir[0].moneda + " " +  this.numeroALetras(vm.dessertImprimir[0].total) , 10, finalO); 


        //        // doc.text("Son:  " + vm.dessertImprimir[0].moneda + " " + this.numeroALetras(vm.dessertImprimir[0].total).charAt(0).toUpperCase() + this.numeroALetras(vm.dessertImprimir[0].total).slice(1), 10, finalO);

               

        //        doc.text("Son:  " + vm.dessertImprimir[0].moneda + " " + this.numeroALetras( vm.dessertImprimir[0].total.toString().replace(/\./g, "").replace(",", ".")) , 10, finalO);

        //         finalO = finalO + 5;

        //         doc.text("B.N.A Cotización de Divisas tipo vendedor, dia anterior al pago"  , 10, finalO);    


        //         finalO = finalO + 10;

        //         doc.setFontSize(8);
        //         doc.text("LUGAR DE ENTREGA:  " +  vm.dessertImprimir[0].lugar  , 10, finalO);    
        //         finalO = finalO + 5;                
        //         doc.text("TRANSPORTE: " +  vm.dessertImprimir[0].transporte  , 10, finalO);
        //         finalO = finalO + 5;       
        //         doc.text("LUGAR DE PAGO:  AV. LA VOZ DEL INTERIOR 5883 (EX MONSEÑOR PABLO CABRERA 5495)" , 10, finalO);                

        //         const pageCount = doc.internal.getNumberOfPages();

        //         for (var i = 1; i <= pageCount; i++) {
        //             doc.setPage(i);
        //             doc.text(
        //             "Página " + String(i) + " de " + String(pageCount),
        //             210 - 20,
        //             297 - 10,
        //             null,
        //             null,
        //             "right"
        //             );
        //         }

        //         doc.save('table.pdf');



        // },



          generarPDF(){
           
         
                    var vm = this;      
                    var columns = [
                    {title: "IT", dataKey: "item"},
                    {title: "Cant.", dataKey: "cantidad"},
                    {title: "Articulo", dataKey: "artic"},
                    {title: "Descripcion", dataKey: "detalle"},
                    {title: "Precio Unit.", dataKey: "precio"},
                    {title: "Importe", dataKey: "totart"},
                   
                    ];

                    var doc = new jsPDF();
                    
                    var rows = vm.dessertImprimir.map(dessertImprimir => ({
                        item: dessertImprimir.item,
                        cantidad: dessertImprimir.cantidad,
                        artic: dessertImprimir.artic,
                        detalle: dessertImprimir.detalle,
                        precio: dessertImprimir.precio,
                        totart: dessertImprimir.totart
                    }));


                    doc.setLineWidth(0.5);

                    doc.line(10, 11, 200, 11);           
                    doc.line(10, 11, 10, 41);
                
                    doc.addImage(
                        "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",
                        "JPEG",
                        15,
                        15,
                        22,
                        22
                    );
                    doc.setFontSize(6);
                    doc.text("X" , 100, 15);
                    doc.setFontSize(5);
                    doc.text("Documento no valido como factura" , 88, 17);

                    let npA = vm.dessertImprimir[0].id + " - " + vm.dessertImprimir[0].np;
                    let provA= vm.dessertImprimir[0].proveedorC + " - " + vm.dessertImprimir[0].proveedorN;

                    doc.setFontSize(13);
                   

                    // doc.setFillColor(220, 220, 220); // Gris claro (RGB)
                    // doc.rect(40, 20, 80, 8, "F"); // Dibuja un rectángulo de fondo

                    // doc.setTextColor(0, 0, 0); // Texto en negro

                    doc.setFont("times", "italic"); // Fuente: times, estilo: italic
                    doc.text("NOTA DE PEDIDO N°: " + npA, 42, 25);

                    doc.setFontSize(12);

                    doc.setFont("times", "normal");
                    doc.setFontSize(12);
                    doc.text("FECHA DE EMISION: " + vm.dessertImprimir[0].fecha  , 132, 25);

                    doc.setFontSize(8);
                    doc.text("SEÑOR(ES): " + provA  , 42, 31);

                    let domi = vm.dessertImprimir[0].calle + " " + vm.dessertImprimir[0].barrio + " " +   vm.dessertImprimir[0].ciudad ;

                    doc.setFontSize(7);
                    doc.text("" + domi  , 59, 36);

                    doc.setFontSize(7);
                    doc.text("COMPRADOR: " +  vm.dessertImprimir[0].comprador  , 10, 47);  

                    doc.setFontSize(8);
                    doc.text("CONDICIONES DE PAGO: " +  vm.dessertImprimir[0].condicion  , 10, 52);                    
                    doc.text("REAJUSTE DE PRECIOS: " +  vm.dessertImprimir[0].reajuste  , 10, 57);
                    doc.text("PLAZO DE ENTREGA: " +  vm.dessertImprimir[0].plazo  , 10, 62);

                   
                     doc.line(40, 11, 40, 41);                    
                    
                    doc.line(10, 41, 200, 41);
                    doc.line(200, 11, 200, 41);
                    doc.setFontSize(10);
               
                    let subtotal = vm.dessertImprimir[0].subtotal;
                    let descuento = vm.dessertImprimir[0].descuento;
                    let neto = vm.dessertImprimir[0].neto;
                    let total = vm.dessertImprimir[0].total;
                    let ivaa = vm.dessertImprimir[0].iva;



                    // Agregar la fila extra al final con los totales
                    rows.push(
                        { item: "", cantidad: "", artic: "", detalle: "", precio: "SUBTOTAL", totart: subtotal },
                        { item: "", cantidad: "", artic: "", detalle: "", precio: "DESCUENTO", totart: descuento },
                        { item: "", cantidad: "", artic: "", detalle: "", precio: "NETO", totart: neto },
                        { item: "", cantidad: "", artic: "", detalle: "", precio: "IVA(21,00%)", totart: ivaa },
                        { item: "", cantidad: "", artic: "", detalle: "", precio: "TOTAL",  totart: vm.dessertImprimir[0].moneda + ' ' + total  }
                     
                    );

                  //  Generar la tabla con estilos

                    doc.autoTable({
                        columns: columns,
                        body: rows, // Incluir los datos + la fila de totales
                        startY: 65, // Posición de inicio
                        margin: { top: 25, left: 10, right: 10 },
                        styles: { fontSize: 8 },
                        headStyles: { fillColor: [41, 128, 185], textColor: [255, 255, 255] }, // Azul en el encabezado
                        bodyStyles: { textColor: [0, 0, 0], fillColor: [255, 255, 255] }, // Fondo blanco en el cuerpo
                        columnStyles: {
                            precio: { fontStyle: "bold", halign: "right" }, // Alinear textos de SUBTOTAL, etc.
                            totart: { fontStyle: "bold", halign: "right" }  // Alinear valores numéricos
                        },                       
                       

                        didParseCell: function (data) {    
                            if (data.section === 'head' && data.column.dataKey === 'totart') {
                                data.cell.styles.halign = 'right';
                            }                       
                            // Pintar la fila de SUBTOTAL, DESCUENTO, NETO y TOTAL en gris
                            if (data.row.index >= rows.length - 4) {
                                data.cell.styles.fillColor = [200, 200, 200]; // Gris claro
                                data.cell.styles.fontStyle = "bold";
                            }

                            // Pintar la fila de TOTAL con un gris más oscuro
                            if (data.row.index === rows.length - 1) {
                                data.cell.styles.fillColor = [150, 150, 150]; // Gris más oscuro
                                data.cell.styles.fontStyle = "bold";                               
                                data.cell.styles.textColor = [255, 255, 255]; // Texto en blanco 
                                 // SOLO columna 'totart' de la fila TOTAL
                                if (data.column.dataKey === 'totart') {
                                    data.cell.styles.fontSize = 9; // ajustar tamaño si es necesario
                                    data.cell.styles.cellWidth = 'wrap'; // evita forzar salto
                                }

                                // SOLO columna 'precio' (que dice "TOTAL")
                                if (data.column.dataKey === 'precio') {
                                    data.cell.styles.fontSize = 9;
                                }                              

                            }

                           
                        }
                    });



                   



                    

                    var finalO =  doc.autoTable.previous.finalY + 20;

                    if (finalO >= 285) {
                        doc.addPage();
                        finalO = 0;
                    }


                    
                   
                    finalO = finalO + 3;

                    doc.setFontSize(8);

                    let total1 = vm.dessertImprimir[0].total;

                    // Reemplaza separadores de miles y convierte a número decimal
                    total1 = parseFloat(total1.replace(/\./g, "").replace(",", "."));

                   
                    //doc.text("Son:  " + vm.dessertImprimir[0].moneda + " " +  this.numeroALetras(vm.dessertImprimir[0].total) , 10, finalO); 
                  
                    
                   // doc.text("Son:  " + vm.dessertImprimir[0].moneda + " " + this.numeroALetras(vm.dessertImprimir[0].total).charAt(0).toUpperCase() + this.numeroALetras(vm.dessertImprimir[0].total).slice(1), 10, finalO);

                    doc.setFontSize(11);


                   //doc.text("Son:  " + vm.dessertImprimir[0].moneda + " " + this.numeroALetras( vm.dessertImprimir[0].total.toString().replace(/\./g, "").replace(",", ".")) , 10, finalO);


                    let enLetras = this.numeroALetras(vm.dessertImprimir[0].total.toString().replace(/\./g, "").replace(",", "."));
                    let capitalizada = enLetras.charAt(0).toUpperCase() + enLetras.slice(1);

                    doc.text("Son:  " + vm.dessertImprimir[0].moneda +  " " + capitalizada  , 10, finalO);



                    finalO = finalO + 5;

                    doc.setFontSize(8);

                    doc.text("B.N.A Cotización de Divisas tipo vendedor, dia anterior al pago"  , 10, finalO);    

                  


                    finalO = finalO + 10;

                    doc.setFontSize(8);
                    doc.text("LUGAR DE ENTREGA:  " +  vm.dessertImprimir[0].lugar  , 10, finalO);    
                    finalO = finalO + 5;                
                    doc.text("TRANSPORTE: " +  vm.dessertImprimir[0].transporte  , 10, finalO);
                    finalO = finalO + 5;       
                    doc.text("LUGAR DE PAGO:  AV. LA VOZ DEL INTERIOR 5883 (EX MONSEÑOR PABLO CABRERA 5495)" , 10, finalO);                




                    
                    


                    // doc.text("Lugar de Entrega:  " + vm.desserts3[0].lugEnt  , 10,finalO + 20 );            
                    // doc.text("Ítems con inspección del cliente y/o protocolos de ensayo:  " + vm.desserts3[0].itemIns ,10,finalO + 26 )          
                    // doc.text("Observaciones:  " + vm.desserts3[0].observa , 10,finalO + 32 );     
                    // doc.text("Responsable Tecnico:  "+ vm.desserts3[0].tecnico, 10,finalO+ 45);
                    // doc.text("Responsable Comercial:  "+ vm.desserts3[0].comercial, 10,finalO + 51);



                    
                    
                
                        const pageCount = doc.internal.getNumberOfPages();

                    for (var i = 1; i <= pageCount; i++) {
                        doc.setPage(i);
                        doc.text(
                        "Página " + String(i) + " de " + String(pageCount),
                        210 - 20,
                        297 - 10,
                        null,
                        null,
                        "right"
                        );
                    }

                    doc.save('table.pdf');



            },






        numeroALetras(numero) {
                if (isNaN(numero)) return "Número no válido";

                numero = parseFloat(numero); // Asegurar que sea número
                let parteEntera = Math.floor(numero);
                let parteDecimal = Math.round((numero - parteEntera) * 100); // Extraer decimales (máx. 2 dígitos)

                let texto = this.convertirNumeroEnteroALetras(parteEntera);

                if (parteDecimal > 0) {
                texto += " con " +  this.convertirNumeroEnteroALetras(parteDecimal) + " centavos";
                }

                return texto;
                },

                convertirNumeroEnteroALetras(numero) {
                if (numero === 0) return "cero";

                const unidades = ["", "uno", "dos", "tres", "cuatro", "cinco", "seis", "siete", "ocho", "nueve"];
                const especiales = ["diez", "once", "doce", "trece", "catorce", "quince", "dieciséis", "diecisiete", "dieciocho", "diecinueve"];
                const decenas = ["", "diez", "veinte", "treinta", "cuarenta", "cincuenta", "sesenta", "setenta", "ochenta", "noventa"];
                const centenas = ["", "ciento", "doscientos", "trescientos", "cuatrocientos", "quinientos", "seiscientos", "setecientos", "ochocientos", "novecientos"];

                function convertirMenosDeMil(n) {
                if (n === 100) return "cien";
                let texto = "";
                if (n >= 100) {
                    texto += centenas[Math.floor(n / 100)] + " ";
                    n %= 100;
                }
                if (n >= 10 && n < 20) return texto + especiales[n - 10];
                if (n >= 20) {
                    texto += decenas[Math.floor(n / 10)];
                    if (n % 10 > 0) texto += " y " + unidades[n % 10];
                } else if (n > 0) {
                    texto += unidades[n];
                }
                return texto.trim();
                }

                function convertirSeccion(numero, divisor, singular, plural) {
                let cientos = Math.floor(numero / divisor);
                let resto = numero % divisor;
                let texto = cientos === 1 ? singular : convertirMenosDeMil(cientos) + " " + plural;
                if (resto > 0) texto += " " + convertirMenosDeMil(resto);
                return texto.trim();
                }

                if (numero < 1000) return convertirMenosDeMil(numero);
                if (numero < 1_000_000) return convertirSeccion(numero, 1000, "mil", "mil");
                if (numero < 1_000_000_000) return convertirSeccion(numero, 1_000_000, "un millón", "millones");
                if (numero < 1_000_000_000_000) return convertirSeccion(numero, 1_000_000_000, "mil millones", "mil millones");
                if (numero < 1_000_000_000_000_000) return convertirSeccion(numero, 1_000_000_000_000, "un billón", "billones");

                return "Número demasiado grande";

        },




        exportarExcelNP(){

            let excel=[];
          //  excel= [...this.dessertsFichaNP];

            this.dessertsFichaNP.forEach(element => {
                    excel.push({                               
                                item: element.item == 0 ? "" : element.item,
                                artic:   element.artic == "0" || element.artic == null ? ""  :  element.artic ,
                                cantidad:  element.cantidad == "0" || element.cantidad == null ? "" : element.cantidad  ,
                                dto:  element.dto == "0" || element.dto == null ? "" :  element.dto  ,                               
                                detalle:  element.detalle == "0" ? "" : element.detalle  ,
                                precio: element.precio == "0" || element.precio == null ? "" : (element.precio) ,
                                totart:  element.totart == "0" || element.totart == null ? "" : (element.totart) ,
                                plazo: element.plazo == "0" || element.plazo == null ? ""  : element.plazo  ,
                    })

            });        


            excel.push({
            item: "",
            artic:   "",
            cantidad: "",
            descuento: ""  ,                               
            detalle:  "************** TOTAL *****************" ,
            precio: "" ,
            totart: this.vvTotal,  //this.formatearNumero(this.vvTotal) ,
            plazo: "" ,
            

            });

            console.log("datos del excel", excel)

            const data = excel;

            const fileName = "download";
            const exportType =  exportXlsFile.types.xls;
            exportXlsFile({data, fileName,exportType})



        },


        mostrarRecepcion(){

            this.dessertsRecepcion = [];

            this.loadingDialog =true;

            Axios               
            .get("/Ti/MostrarRecepciones?", {
            params: {
                id: this.varNOTAPED, 
                id1:1,                     
            },
            })
            .then(r => {   

                    console.log("datos de la recepcion", r.data);                 

                    if(r.data.length == 0){
                        this.$swal("", "No existen recepciones para la nota de pedido ingresada", "info");
                        this.loadingDialog =false;
                        this.dialogRecepcion = false;
                        return; 
                    }

                    r.data.forEach(element => {
                       
                        let fechaFormateada = moment(element.fecha, "DD/MM/YYYY HH:mm:ss").format("DD/MM/YYYY");

                        

                        this.dessertsRecepcion.push({

                            recepcion: element.recepcion ,
                            fecha: fechaFormateada ,
                            otrabajo: element.otrabajo,
                            item: element.item,                               
                            cantidad: element.cantidad,
                            serie: element.serie,
                            numero: element.numero ,
                            articulo: element.articulo,
                            descrip: element.descrip,
                            npedido:element.npedido,                           
                            

                        });
                    });

                    this.loadingDialog =false;
                    this.dialogRecepcion = true;


            }).catch(r => {        
                
                this.$swal("", "No se pudo cargar las recepciones", "info")                
                this.loadingDialog =false;

            });

        },
        


        exportarRecepcion(){

                const data = this.dessertsRecepcion;
                const fileName = "download";
                const exportType =  exportXlsFile.types.xls;
                exportXlsFile({data, fileName,exportType})

        },
      


















    }


      

     



    
}
</script>

<style scoped>
  .compacto {
    margin-top: -10px; /* ajustá según necesites */
    margin-bottom: -10px;
    }
</style>